import SectionHeading from "./SectionHeading";

const CONCERNS = [
  { icon: "ri-drop-line", name: "건조함", desc: "당김과 각질로 건조한 피부" },
  { icon: "ri-bubble-chart-line", name: "모공·피지", desc: "넓어진 모공과 번들거림" },
  { icon: "ri-emotion-unhappy-line", name: "트러블", desc: "반복되는 여드름과 자극" },
  { icon: "ri-sun-line", name: "칙칙함", desc: "어둡고 칙칙한 피부톤" },
  { icon: "ri-arrow-down-circle-line", name: "탄력 저하", desc: "처지고 힘 없는 피부" },
  { icon: "ri-heart-3-line", name: "민감함", desc: "예민하고 붉어지는 피부" },
];

export default function SkinConcerns() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <SectionHeading
          eyebrow="Skin Concerns"
          title="어떤 피부 고민이 있으신가요?"
          description="비앙카는 한 가지 해결책이 아닌, 고객님의 피부 고민에 꼭 맞는 관리 프로그램을 제안합니다."
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {CONCERNS.map((concern, index) => (
            <div
              key={concern.name}
              className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-background-50 border border-background-200/70 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <span className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${concern.icon} text-2xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </span>
              <div className="flex flex-col items-center gap-1 text-center">
                <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{concern.name}</span>
                <span className="text-xs text-foreground-500 leading-snug">{concern.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}